import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"

interface HeadProps {
  title: string
  description?: string
  image?: { publicURL: string }
}

export default function Head(props: HeadProps) {
  
  const defaultCardImage = useStaticQuery(
    graphql`
      query {
        file(relativePath: { eq: "bumbershoot-card.jpg" }) {
          publicURL
        }
      }
    `
  )

  return (
    <>
      <meta charSet="utf-8" />
      <title>{props.title}</title>
      {props.description && (
        <meta
          name="description"
          property="og:description"
          content={props.description}
        />
      )}
      {props.description ? 
        <meta
          name="description"
          property="og:description"
          content={props.description}
        />
        :
        <meta
          name="description"
          property="og:description"
          content="Bumbershoot isn't anything without you"
        />
      }
      <meta property="og:title" content={props.title} />
      {props.image?.publicURL? (
        <meta property="og:image" content={`https://bumbershoot.com${props.image?.publicURL}`} />
      ) : (
        <meta property="og:image" content={`https://bumbershoot.com${defaultCardImage.file.publicURL}`} />
      )}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={props.title} />
      {props.description ? 
        <meta name="twitter:description" content={props.description} />
        :
        <meta name="twitter:description" content="Bumbershoot isn't anything without you" />
      }
      {props.image?.publicURL? (
        <meta name="twitter:image" content={`https://bumbershoot.com${props.image?.publicURL}`} />
      ) : (
        <meta name="twitter:image" content={`https://bumbershoot.com${defaultCardImage.file.publicURL}`} />
      )}
    </>
  )
}
